import { selectCanManageAllScreenshares } from 'features/permissions/permissionsSlice';
import { PermissionTypes } from 'features/permissions/types';
import { usePermissions } from 'features/permissions/usePermissions';
import { useAppSelector } from 'store/hooks';

export const useBulkCloseContent = () => {
  const { hasPermissions } = usePermissions();

  const canManageScreenshares = useAppSelector(selectCanManageAllScreenshares);
  const canManageFiles = hasPermissions(PermissionTypes.presentContentLibrary);
  const canManageWhiteboards = hasPermissions(PermissionTypes.editWhiteboard);

  const canManageAllContent = canManageScreenshares && canManageFiles && canManageWhiteboards;

  return {
    canManageAllContent,
    canManageScreenshares,
    canManageFiles,
    canManageWhiteboards,
  };
};
